import { useEffect, useCallback } from 'react'

const PIXEL_ID = '1266968885378116'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

let initialized = false

export function useMetaPixel() {
  useEffect(() => {
    if (initialized) return
    initialized = true

    // Initialize fbq
    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Load the SDK script
    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    // Init and fire PageView
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])

  const trackEvent = useCallback(
    (eventName: string, params?: Record<string, any>) => {
      if (window.fbq) {
        window.fbq('track', eventName, params)
      }
    },
    [],
  )

  return { trackEvent }
}
